// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EditorContainer.__hasErrors .tox-tinymce{border:1px solid red;box-shadow:1px 1px 4px 1px #ff000040;transition:.2s}.ErrorContainer{height:24px}.ErrorContainer .EditorError{overflow:hidden;height:0;color:red;transition:.2s}.ErrorContainer .EditorError.__open{height:24px}.tox-tinymce--disabled .tox-edit-area__iframe{background-color:#f5f5f5 !important}.tox-tinymce{border-radius:4px !important;border:1px solid #d9d9d9 !important}", ""]);
// Exports
module.exports = exports;
